/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：2528
 */

var r = require(/* 2529 */"./2529")
module.exports = function (e) {
  return null == e ? "" : r(e)
}
